import React from 'react';

import Cta from 'component/Layout/Cta';
import { CtaTheme } from 'component/Layout/Cta/types';

import classNames from 'classnames';

import { useIntersectionObserver } from 'hooks/useIntersectionObserver';
import { QaIdentifier, useQa } from 'hooks/useQa';
import { useTranslation } from 'hooks/useTranslation';

import { ReactComponent as IconUserCircleEmpty } from 'media/svg/userCircleEmpty.svg';

import { trackGa4Event } from 'utility/Track/trackingHelper';
import { openLoginLayer } from 'utility/Trigger/openLoginLayer';

import { LoginTheme } from '../../types';

import styles from './Section.module.scss';

interface SectionProps {
    theme?: LoginTheme;
}

const Section = ({ theme }: SectionProps) => {
    const { t } = useTranslation();
    const qaAttr = useQa(QaIdentifier.Login_Banner);
    const observerCallback = () => {
        trackGa4Event('loginBanner_impression', {});
    };
    const observerRef = useIntersectionObserver(
        {
            rootMargin: '0px',
            checkVisibilityOnFastScroll: true,
            triggerOnce: true,
        },
        observerCallback
    );

    const handleClick = () => {
        openLoginLayer();
        trackGa4Event('loginBanner_click_open', {});
    };

    return (
        <section
            {...qaAttr}
            ref={observerRef}
            className={classNames(styles.Section, {
                [styles.Color]: theme === LoginTheme.COLOR,
                [styles.Light]: theme === LoginTheme.LIGHT,
            })}
        >
            <div className={styles.Login}>
                <div className={styles.Content}>
                    <div className={styles.Icon}>
                        <IconUserCircleEmpty />
                    </div>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: t(
                                'TRANS-login-and-benefit-from-advantages'
                            ),
                        }}
                    />
                </div>
                <Cta
                    theme={CtaTheme.INVERTED}
                    children={t('TRANS-login')}
                    customClassList={{
                        Cta: styles.Button,
                    }}
                    onClick={handleClick}
                />
            </div>
            {theme === LoginTheme.LIGHT && (
                <a onClick={handleClick} className={styles.AreaLink}></a>
            )}
        </section>
    );
};

export default Section;
